import React from 'react';
import { FiRefreshCw } from 'react-icons/fi';
import './MaintenancePage.css';

const KOSTU_CAMPUS_IMAGE =
  'https://kocaelisaglik.edu.tr/wp-content/uploads/2022/04/kostu_giris_foto.jpg';

/**
 * Site genelinde bakım modu etkinleştirildiğinde gösterilen bağımsız ekran.
 * KOSTÜ ana sayfasındaki kampüs görseli ve kurumsal renkler kullanılır.
 */
function MaintenancePage() {
  return (
    <main
      className="maintenance-page"
      style={{ '--maintenance-campus-image': `url("${KOSTU_CAMPUS_IMAGE}")` }}
      aria-labelledby="maintenance-title"
    >
      <div className="maintenance-page__backdrop" aria-hidden="true" />
      <div className="maintenance-page__network" aria-hidden="true" />

      <section className="maintenance-card">
        <img
          className="maintenance-card__logo"
          src="/KOSTU-Yuvarlak-Logo.png"
          alt="Kocaeli Sağlık ve Teknoloji Üniversitesi"
        />

        <div className="maintenance-card__icon" aria-hidden="true">
          <FiRefreshCw />
        </div>

        <h1 id="maintenance-title">Proje güncellenmektedir</h1>
        <p className="maintenance-card__message">
          Hizmetimizi daha iyi hâle getirmek için kısa süreli bir güncelleme yapıyoruz.
        </p>

        <div className="maintenance-card__divider" aria-hidden="true" />
        <p className="maintenance-card__university">Kocaeli Sağlık ve Teknoloji Üniversitesi</p>
        <p className="maintenance-card__team">Yazılım Geliştirme Ekibi</p>
      </section>
    </main>
  );
}

export default MaintenancePage;
